class Tooltip {

  constructor(elem) {
    this.tooltip = elem;
    this.tooltipBtn = this.tooltip.parent().find('[data-tooltip-button]');
    this.close = this.tooltip.find('[data-tooltip-close]');
    this.size = this.tooltip.find('[data-tooltip-size]');
	}

  initialize() {
    let that = this;

    if (this.tooltip.closest('[data-cart-list]').length > 0) {
      this.tooltip.closest('[data-cart-list]').on('scroll', function() {
        that.tooltip.removeClass('open');
        that.tooltip.parent().find('[data-tooltip-button]').removeClass('open');
      })
    }

    $('body').on('click', function() {
      that.tooltip.removeClass('open');
      that.tooltip.parent().find('[data-tooltip-button]').removeClass('open');
    })

    this.tooltip.on('click', function(e) {
      e.stopPropagation()
    });

    // открытии тултипа по клику
    this.tooltipBtn.on('click', function(e) {
      let el = $(this);
      el.toggleClass('open')
      that.tooltip.toggleClass('open');

      $('[data-tooltip-close]').trigger('click')

      e.preventDefault();
      e.stopPropagation()
    });

    // закрытие тултипа
    this.close.on('click', function(e) {
      let el = $(this);
      el.closest('[data-tooltip]').removeClass('open');
      el.closest('[data-tooltip]').parent().find('[data-tooltip-button]').removeClass('open');

      e.preventDefault()
    });

    // отображение детальной информации по размерам
    this.size.on('mouseenter', function(e) {
      let el = $(this);

      that.loadSize(el);

      e.preventDefault()
    });

    // отображение выбранного размера
    this.size.on('mouseleave', function(e) {
      let el = $(this);

      that.loadSize(el);

      e.preventDefault()
    });

    this.size.on('click', function(e) {
      let el = $(this);
      that.loadSize(el, true);

      e.preventDefault()
    });

    $('[data-cart-change-size].active').trigger('mouseenter')
  }

  setDefaultSize(el) {
    let size = $('[data-cart-change-size].active').attr('data-tooltip-size').split(' ');
    let parent = el.closest('[data-tooltip]');
    let info = parent.find('[data-tooltip-size-info]');

    for (let i = 0; i < size.length; i++) {
      info.children().eq(i).find('[data-tooltip-size-res]').text(size[i]);
    }
  }

  loadSize(el, close = false) {
    let size = el.attr('data-tooltip-size').split(' ');
    let parent = el.closest('[data-tooltip]');
    let info = parent.find('[data-tooltip-size-info]');
    let isTooltipster = el.closest('[data-tooltipster-popup]').length > 0? true: false;

    for(let i = 0; i < size.length; i++) {
      info.children().eq(i).find('[data-tooltip-size-res]').text(size[i]);
    }

    if (close) {
      el.closest('[data-product-size]').find('[data-tooltip-size]').removeClass('active');
      el.addClass('active')

      if (typeof el.attr('data-size-label') !== 'undefined' && el.attr('data-size-label').trim().length) {
        if (!isTooltipster) {
          this.tooltipBtn.text(el.attr('data-size-label').trim())
        } else {
          $('[data-tooltip-button]').each(function() {
            if ($(this).hasClass('open')) {
              $(this).text(el.attr('data-size-label').trim())
            }
          })
        }
      } else {
        if (!isTooltipster) {
          this.tooltipBtn.text(size[0])
        } else {
          $('[data-tooltip-button]').each(function() {
            if ($(this).hasClass('open')) {
              $(this).text(size[0])
            }
          })
        }
      }

      if (!isTooltipster) {
        parent.removeClass('open');
        parent.parent().find('[data-tooltip-button]').removeClass('open');
      } else {
        $('[data-tooltip-content]').tooltipster('hide');
      }
    }
  }
}

export {Tooltip};

$(function () {
  window.Tooltip = Tooltip;
});

$(window).on('load', () => {
  let tooltip = [];

  if ($('[data-tooltip]').length > 0) {
		$('[data-tooltip]').each(function(i) {
			tooltip[i] = new Tooltip($(this));
			tooltip[i].initialize();
		});
	}
});
